import { Scene } from 'three';

/**
 * Creates and returns a new Three.js Scene.
 * @returns {THREE.Scene} The created scene.
 */
export function createScene() {
  return new Scene();
}